import React, { Component } from "react";
import { Floating, translate } from '@haldor/ui';
import { connect } from "react-redux";
import { Form, Field } from "react-final-form";
import { withRouter } from 'react-router-dom';

import { addError } from "actions";
import { clearSelectedSections, toggleSelectedSection } from "actions/sections";
import { getPlanDetails, updatePlan, createPlan } from "actions/plans";

import { getGroupById } from "actions/groups";
import Swal from 'sweetalert2';

import {
	saveBlocksOnReference,
	updateBlocksOnReference,
	deleteBlock,
	createAssessmentBlock,
	updateAssessmentBlock,
} from 'actions/blocks';

import { getRootUrl } from "helpers/url";

import BlockEditor from 'components/BlockEditor';
import BlockAssessments from 'components/BlockAssessments';
import BlockPurpose from "components/Inputs/BlockPurposeField";
import BlockCoreContentField from "components/Inputs/BlockCoreContentField";
import Select from "components/Inputs/select";

import DatePickerFromTo from "../Partials/DatePickerFromTo";
import GroupSelector from "../Partials/GroupSelector";

import TeacherAdjustments from "containers/AdditionalAdjustments/Display/TeacherAdjustments";

import { Checkbox, Button } from '@haldor/ui';
import { Expandable, Spinner } from "UI";
import api from "lib/api";
import moment from "moment";


import { appInsights } from "lib/appInsights";
import { Stack } from "@mui/material";
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';


class SinglePlanForm extends Component {

	constructor(props) {
		super(props);
		const { initialValues, editView } = props;

		this.state = {
			dateStart: null,
			dateEnd: null,
			status: null,
			groupId: 0,
			loading: false,
			students: editView && initialValues != null ? initialValues.students : [],
			enableAutoAssign: initialValues != null ? initialValues.autoAssignStudents : null,
			deletedBlocks: [],
			deletedAssessmentBlocks: [],
			group: null,
			isSaving: false
		};

		// Define form reference
		this.formRef = null;
	}

	componentDidMount = () => {
		this.setState({ loading: true });

		if (this.props.cloneView) {
			this.props.getPlanDetails(this.props.plan.id).then(() => {
				this.setState({ loading: false });
			});
		}
		let groupId = null;
		if (this.props.initialValues != null) {
			groupId = this.props.initialValues.sectionId;
			this.setState({ dateStart: this.props.initialValues.timeStart, dateEnd: this.props.initialValues.timeEnd });
		}

		if (this.props.groupId != null) {
			groupId = this.props.groupId;
		}

		if (groupId != null) {
			this.setState({ groupId: groupId });
			this.props.getGroupById(groupId, ['members', 'owners', 'courses']).then((group) => {
				if (!this.props.editView) {
					this.setState({ students: group.members });
				}
				this.setState({ loading: false, group: JSON.parse(JSON.stringify(group)) });
				this.props.toggleSelectedSection(group);
			});
		} else {
			this.setState({ loading: false });
		}
	};
	componentWillUnmount = () => {
		this.props.clearSelectedSections();
	}

	reCheckAutoAssign = () => {

		if (this.formRef != null) {
			// Calculate the new value of enableAutoAssign based on current state/props
			const enableAutoAssign =
				this.state.students != null &&
				this.state.group != null &&
				this.state.group.members != null &&
				this.state.group.members.every(student => { return this.state.students.some(selectedStudent => selectedStudent.id === student.id) });

			// Update only if enableAutoAssign value changes
			if (!enableAutoAssign) {
				this.formRef.mutators.setAutoAssignStudents(false);
			}
		}
	};

	/* Redux form functions */
	required = (value) => {
		if (typeof value !== "undefined" && value !== "") {
			if (value.length > 199) {
				// Field failed validation, return error for this field (String)
				return this.props.translate("field-max-200-chars");
			}

			// Field passes validation, return a undefined error for this field
			// Rule: Not undefined and not an empty string and not over 200 characters
			return undefined;
		}

		// Field failed validation, return error for this field (String)
		return this.props.translate("field-needs-input");
	};


	submit = (values) => {
		const { translate, initialValues } = this.props;
		const { dateStart, dateEnd, groupId, status } = this.state;

		if (!groupId) {
			this.props.addError(translate("pick-a-section"), "error");
			return;
		}

		this.setState({ isSaving: true });

		const preparedValues = { ...values };
		preparedValues.timeStart = moment(dateStart).startOf('day');
		preparedValues.timeEnd = moment(dateEnd).endOf('day').subtract(1, 'minute');
		preparedValues.sectionId = groupId;
		preparedValues.students = this.state.students?.filter(t => !t.remove) ?? [];
		if (status) preparedValues.status = status;

		return new Promise(async (resolve) => {
			const executeSubmit = async (data) => {
				try {
					let blocks = data.blocks ?? [];
					let assessmentBlocks = data.assessmentBlocks ?? [];
					let promises = [];

					blocks = blocks.map(block => {
						if (block.type === 'Haldor.Blocks.Assignment' && block.resources) {
							const updatedResources = [];
							block.resources.forEach(resource => {
								if (resource.existing) {
									assessmentBlocks.forEach(assessmentBlock => {
										promises.push((async () => {
											const assignmentId = resource['@odata.type'] === 'haldor.assignment.block.teamsassignment'
												? (await api.get(`assignments/${resource.id}/details`)).data.id
												: resource.id;
											return this.props.createAssessmentBlock(assessmentBlock, assignmentId, 'ASSIGNMENT');
										})());
									});
								}
								updatedResources.push({ id: resource.id, '@odata.type': resource['@odata.type'] });
							});
							block.resources = updatedResources;
						}
						return block;
					});

					if (!this.props.editView || this.props.cloneView === true) {
						await this.props.createPlan(data);
						const planId = this.props.createdPlan.id;
						let newBlocks = blocks?.map(block => ({ ...block, id: 0 })) ?? [];
						if (data.assessmentBlocks) {
							data.assessmentBlocks.forEach((block) => {
								const blockCopy = { ...block, resources: block.resources.map(r => ({ ...r, originId: r.id, id: 0 })) };
								promises.push(this.props.createAssessmentBlock(blockCopy, planId, 'PLAN'));
							});
						}
						if (newBlocks?.length) {
							const filteredBlocks = newBlocks.filter(b => b.type !== 'Haldor.Blocks.AssessmentBlock');
							promises.push(this.props.saveBlocksOnReference(filteredBlocks, planId, 'PLAN'));
						}
						await Promise.all(promises);
						this.setState({ isSaving: false });
						const redirectUrl = `${getRootUrl()}plan/${planId}`;
						if (this.props.cloneView) { window.location = redirectUrl; } else { this.props.history.push(redirectUrl); }
					} else {
						promises.push(this.props.updatePlan(data));
						promises.push(this.props.updateBlocksOnReference(blocks, initialValues.id, 'PLAN'));
						promises.push(...assessmentBlocks.map(async (block) => {
							const initialBlock = this.props.initialValues.assessmentBlocks.find(b => b.id === block.id);
							return initialBlock ? this.props.updateAssessmentBlock(block, initialBlock) : this.props.createAssessmentBlock(block, initialValues.id, 'PLAN');
						}));
						this.state.deletedBlocks.forEach(b => promises.push(this.props.deleteBlock(b.id)));
						this.state.deletedAssessmentBlocks.forEach(b => promises.push(this.props.deleteBlock(b.id)));
						await Promise.all(promises);
						this.setState({ isSaving: false });
						this.props.onAbort(true, true);
					}

					resolve();

				} catch (error) {
					const result = await Swal.fire({
						title: translate('The form could not be saved'),
						text: translate('Something went wrong when we tried to save the form. Please check your connection and try again.'),
						showCancelButton: true,
						confirmButtonText: translate('Try saving again'),
						cancelButtonText: translate('Cancel')
					});

					if (result.isConfirmed) {
						await executeSubmit(data);
					} else {
						this.setState({ isSaving: false });
						resolve();
					}
				}
			};

			await executeSubmit(preparedValues);
		});
	};

	onDateChange = (dates) => {
		this.setState({ dateStart: dates.start, dateEnd: dates.end });
	};

	onGroupSelect = (groupId) => {
		if (groupId != 0) {
			this.setState({ groupId: groupId }, () => {
				this.props.getGroupById(groupId, ['members', 'owners', 'courses']).then((group) => {
					this.setState({ group: JSON.parse(JSON.stringify(group)), students: group?.members });
				});
			});
		} else {
			this.setState({ groupId: 0 });
		}
	};

	onStatusSelect = event => {
		this.setState({ status: event.target.value });
	};

	renderStudents = () => {
		const { group } = this.state;
		const { groupId } = this.state;

		if (group != null && groupId != 0 && groupId != null) {
			let sectionStudents = this.getSectionStudents();
			const sortedStudents = sectionStudents.sort((a, b) => (a.lastName || "").localeCompare(b.lastName || ""));

			return sortedStudents.map((student) => {
				let checked = false;
				let disabled = false;

				this.state.students.find((studentPlan) => {
					if (studentPlan.id == student.id) {
						checked = true;
						if (studentPlan.remove) {
							checked = false;
						}

						if (this.props.assessments != null && this.props.editView) {
							this.props.assessments.find((assessment) => {
								if (assessment.studentId == student.id) {
									disabled = true;
								}
							});
						}
					}
				});

				let title = student.firstName + " " + student.lastName;
				if (disabled && this.props.editView) {
					title += " (" + this.props.translate("assessed") + ")";
				}

				if (student.missing) {
					title += " (" + this.props.translate("removed-from-group") + ")";
				}

				return (
					<div style={{ marginTop: "1em" }} key={student.id}>
						<Checkbox
							name="studentSelect"
							value={checked}
							disabled={disabled}
							onChange={() => {
								this.onStudentSelect(student);
							}}
							label={title}
						/>
					</div>
				);
			});
		} else {
			return (
				<div>{this.props.translate("select-a-group-to-continue")}</div>
			);
		}
	};

	getSectionStudents() {
		let sectionStudents = this.state.group.members;

		// Only get missingStudents when not in copy mode
		if (!this.props.cloneView) {
			let missingStudents = this.state.students.filter(
				t => sectionStudents.find(s => s.id == t.id) == null
			);

			missingStudents.forEach((student) => {
				student.firstName = student.firstname;
				student.lastName = student.lastname;
				student.missing = true;
			});

			sectionStudents = sectionStudents.concat(missingStudents);
		}
		return sectionStudents;
	}

	onStudentSelect = student => {
		let foundStudent = false;
		student.firstname = student.firstName;
		student.lastname = student.lastName;
		this.state.students.find((studentPlan) => {
			if (studentPlan.id == student.id) {
				foundStudent = true;
			}
		});

		let students = this.state.students;
		if (foundStudent) {
			if (student.missing && !student.remove) {
				student.remove = true;
			} else if (student.missing && student.remove) {
				student.remove = false;
			} else {
				students = students.filter(t => t.id != student.id);
			}
		} else {
			students.push(student);
		}

		this.setState({ students }, (() => {
			this.reCheckAutoAssign();
		}));
	};

	renderInput = ({ input, label, type, placeholder, meta: { touched, error, warning } }) => {
		return (
			<div>
				<input
					type={type}
					placeholder={placeholder || label}
					onKeyPress={e => {
						if (e.key == 'Enter') {
							e.preventDefault();
						}
					}}
					style={touched && error ?
						{ border: "1px solid red" }
						: {}}
					{...input}
				/>

				{touched &&
					((error && (
						<span style={{ marginTop: "1rem", color: "red" }}>
							{error}
						</span>
					)) ||
						(warning && (
							<span style={{ marginTop: "1rem", color: "red" }}>
								{warning}
							</span>
						)))}
			</div>
		);
	};

	handleCancel = (event) => {
		event.preventDefault();
		this.props.onAbort(true, false);
	};
	handleBlocksChange = (newBlocks) => {
		if (!Array.isArray(newBlocks) || !Array.isArray(this.props.initialValues?.blocks)) {
			return;
		}
		const oldBlocks = this.props.initialValues.blocks;
		let newlyDeletedBlocks = oldBlocks.filter(
			b => !newBlocks.some(nb => nb?.id === b?.id)
		);

		newlyDeletedBlocks = newlyDeletedBlocks.filter(
			b => b?.type !== "Haldor.Blocks.AssessmentBlock"
		);

		if (newlyDeletedBlocks.length > 0) {
			this.setState(prevState => {
				// Get the current deleted block in array, should only be one.
				const currentDeletedBlocks = newlyDeletedBlocks.filter(
					nb => !prevState.deletedBlocks.some(db => db?.id === nb?.id)
				);

				if (currentDeletedBlocks.length === 1) {
					appInsights.trackTrace({
						message: "EDU024A | Pressed delete on block"
					}, {
						properties: {
							category: "planningForm-" + currentDeletedBlocks[0].referenceId,
							blockId: currentDeletedBlocks[0].id,
							valueLength: currentDeletedBlocks[0].value != null ? currentDeletedBlocks[0].value.length : 0,
						}
					});
					return {
						deletedBlocks: [...prevState.deletedBlocks, currentDeletedBlocks[0]],
					};
				} else if (currentDeletedBlocks.length > 1) {
					appInsights.trackTrace({
						message: "EDU024A | Multiple blocks for deletion, ignoring delete"
					}, {
						properties: {
							category: "planningForm-" + currentDeletedBlocks[0].referenceId,
							blockId: currentDeletedBlocks[0].id,
							valueLength: currentDeletedBlocks[0].value != null ? currentDeletedBlocks[0].value.length : 0,
						}
					});
				}
				return null;
			});
		}
	};
	handleAssessmentBlocksChange = (newBlocks) => {
		if (!Array.isArray(newBlocks) || !Array.isArray(this.props.initialValues?.assessmentBlocks)) {
			return;
		}
		const oldAssessmentBlocks = this.props.initialValues.assessmentBlocks;

		let newlyDeletedBlocks = oldAssessmentBlocks.filter(
			b => !newBlocks.some(nb => nb?.id === b?.id)
		);

		newlyDeletedBlocks = newlyDeletedBlocks.filter(
			b => b?.type === "Haldor.Blocks.AssessmentBlock"
		);

		if (newlyDeletedBlocks.length > 0) {
			this.setState(prevState => {
				const currentDeletedBlocks = newlyDeletedBlocks.filter(
					nb => !prevState.deletedAssessmentBlocks?.some(db => db?.id === nb?.id)
				);

				if (currentDeletedBlocks.length === 1) {
					const deletedBlock = currentDeletedBlocks[0];

					appInsights.trackTrace(
						{ message: "EDU024B | Pressed delete on assessment block" },
						{
							properties: {
								category: "planningForm-" + deletedBlock.referenceId,
								blockId: deletedBlock.id,
								valueLength: deletedBlock.value != null ? deletedBlock.value.length : 0,
							},
						}
					);

					return {
						deletedAssessmentBlocks: [...(prevState.deletedAssessmentBlocks || []), deletedBlock,]
					};
				} else if (currentDeletedBlocks.length > 1) {
					const firstBlock = currentDeletedBlocks[0];

					appInsights.trackTrace(
						{ message: "EDU024B | Multiple assessment blocks for deletion, ignoring delete" },
						{
							properties: {
								category: "planningForm-" + firstBlock.referenceId,
								blockId: firstBlock.id,
								valueLength: firstBlock.value != null ? firstBlock.value.length : 0,
							},
						}
					);
				}

				return null;
			});
		}
	};

	render() {
		const { initialValues } = this.props;
		const { groupId } = this.state;
		const statuses = this.props.status.planningStatus.filter(t => t.selectable);

		let dates = {
			timeStart: this.state.dateStart,
			timeEnd: this.state.dateEnd,
		}

		return (
			<div className="form-container form">
				<Form
					onSubmit={this.submit}
					mutators={{
						setStatusDraft: (args, state, utils) => {
							utils.changeValue(state, 'status', () => 'PLANNING_DRAFT');
						},
						setStatusOpen: (args, state, utils) => {
							utils.changeValue(state, 'status', () => 'PLANNING_OPEN');
						},
						setAutoAssignStudents: (args, state, utils) => {
							utils.changeValue(state, 'autoAssignStudents', () => args[0]);
						},
					}}
					initialValues={this.props.initialValues}
					render={({ submitting, handleSubmit, form, valid }) => {
						this.formRef = form;
						let blocks = form.getFieldState('assessmentBlocks')?.value;
						let subjects = [];

						if (this.state.group != null && blocks?.length > 0) {
							blocks?.forEach((content) => {
								content?.resources?.forEach(resources => {
									resources?.value?.details?.forEach(details => {
										let course = this.state.group.courses.find(course => {
											return course.details.find((detail) => {
												return detail.id == details.id;
											})
										})
										if (course != null) {
											if (subjects.indexOf(course.subjectId) == -1) {
												subjects.push(parseInt(course.subjectId));
											}
										}
									});

								})
							});
						}

						/**
						 * Enable the auto assign option if all groups have all students selected
						 */
						let enableAutoAssign = this.state.students != null &&
							this.state.group != null &&
							this.state.group.members != null &&
							this.state.group.members.every(student => { return this.state.students.some(selectedStudent => selectedStudent.id === student.id) });

						return (
							<form onSubmit={handleSubmit} className="form form-component">
								{this.state.isSaving ? (
									<div className="is_sending">
										<p>
											<span className="loading-spinner" />
										</p>
									</div>
								) : null}

								<div className="form-row">
									{!this.props.editView ?
										<GroupSelector
											disabled={
												this.props.groupId != null && this.props.cloneView == false ? true : false
											}
											required
											onChange={this.onGroupSelect}
											sectionId={this.state.groupId}
										/>
										: null}
								</div>

								<div style={{ marginTop: "0.5em" }}>
									<Expandable title={this.props.translate("students")}>
										{this.renderStudents()}
									</Expandable>
								</div>


								<div className="form-row mt-4 mb-4">
									<Field name="autoAssignStudents" type="checkbox">
										{({ input }) => {
											return (
												<Stack direction="row" sx={{
													justifyContent: "flex-start",
													alignItems: "center",
												}} spacing={2}>

													<Checkbox
														{...input}
														onChange={(event) => {
															input.onChange(event);
														}}
														value={input.checked}
														disabled={!enableAutoAssign}
														checked={input.checked}
														label={this.props.translate(
															'The plan should also be assigned to students who join the selected groups.'
														)}
													/>
													<div className="helper-text">
														<Floating trigger={(<HelpOutlineRoundedIcon sx={{ fontSize: '1.3rem' }} />)}>
															{this.props.translate('For new students to be automatically assigned to the plan, entire groups must be selected, meaning all students in the selected groups.')}
														</Floating>
													</div>
												</Stack>
											)
										}
										}
									</Field>
								</div>

								{this.props.editView && initialValues.status != "PLANNING_DRAFT" ?
									<div className="form-row">
										<Select
											name="type"
											label={this.props.translate("Status")}
											dataType="plan"
											options={statuses}
											placeholder={false}
											onChange={this.onStatusSelect}
											selectedValue={initialValues.status}
										/>
									</div>
									: null}


								<div className="form-row">
									<DatePickerFromTo
										type="plan"
										onChange={this.onDateChange}
										values={dates}
										cloneView={this.props.cloneView}
									/>
								</div>

								<div className="form-row input">
									<label>{this.props.translate("title")}*</label>

									<Field
										component={this.renderInput}
										type="text"
										name="title"
										placeholder={this.props.translate("title")}
										validate={this.required}
									/>
								</div>

								<div className="form-divider" />

								<Expandable title={this.props.translate('Assessments')}>
									<Field
										component={BlockAssessments}
										name="assessmentBlocks"
										assessmentFeedbackParts={this.props.cloneView ? null : this.props.assessments.reduce((prev, current, index) => {
											return [
												...prev,
												...this.props.assessments[index]?.assessmentFeedbacks?.map((feedback) =>
													feedback.assessmentBlockPartId
												)
											]
										}, [])}
										disableRows={this.props.cloneView ? null : this.props.assessments.reduce((prev, current, index) => {
											return [
												...prev,
												...this.props.assessments[index]?.assessmentDetails?.map((detail) =>
													detail.assessmentBlockPartRowId
												)
											]
										}, [])}
										onChange={this.handleAssessmentBlocksChange}
									/>
								</Expandable>

								<Expandable title={this.props.translate('purpose')}>
									<div className="form-row" style={{ padding: 0, marginBottom: "1em" }}>
										<div className="conditional-groups-container">
											<div className="conditional-groups-container">
												<Field
													name="viewablePurpose"
													component={Checkbox}
													label={this.props.translate("Show purpose to students and guardians")}
													value={true}
												/>
											</div>
										</div >
									</div>

									<Field
										component={BlockPurpose}
										name="purpose"
										assessmentBlocks={blocks}
									/>
								</Expandable >

								<Expandable title={this.props.translate("central-content")}>
									<div className="form-row" style={{ padding: 0, marginBottom: "1em" }}>
										<div className="conditional-groups-container">
											<Field
												name="viewableCoreContent"
												component={Checkbox}
												label={this.props.translate("Show-subject-lesson-content-to-students-and-guardians")}
												value={true}
											/>
										</div>

										<div style={{ clear: "both" }} />
									</div>

									<Field
										component={BlockCoreContentField}
										name="associatedCoreContent"
										referenceId={initialValues?.id}
									/>
								</Expandable>

								{this.props.services.additionalAdjustments ?
									<Expandable
										title={this.props.translate("additional-adjustments")}
										onChange={(expanded) => this.setState({ additionalAdjustmentsExpanded: expanded })}
									>
										{this.state?.additionalAdjustmentsExpanded && (
											<TeacherAdjustments
												disableCommenting={true}
												groupId={groupId != 0 ? groupId : null}
												subjects={subjects}
											/>
										)}
									</Expandable>
									: null}

								<Field
									component={BlockEditor}
									name="blocks"
									user={this.props.currentUser}
									onChange={this.handleBlocksChange}
									groupId={groupId != 0 ? groupId : null}
								/>


								<div className="form-divider" />

								<div className="form-row spacing submit">
									<Button
										onClick={(e) => {
											e.preventDefault();
											form.mutators.setStatusOpen();
											handleSubmit();
										}}
										disabled={this.state.isSaving || !valid || groupId == null || groupId == 0}
									>
										{this.props.editView && initialValues.status !== "PLANNING_DRAFT" ?
											this.props.translate("save")
											: this.props.translate("publish")}
									</Button>

									{this.props.editView && initialValues.status != "PLANNING_DRAFT" ? null :
										<Button
											onClick={(e) => {
												e.preventDefault();
												form.mutators.setStatusDraft();
												handleSubmit();
											}}
											type="secondary"
											disabled={this.state.isSaving || !valid || groupId == null || groupId == 0}
										>
											{this.props.translate("save-draft")}
										</Button>
									}

									<div className="align-right">
										<Button type="secondary" onClick={this.handleCancel}>
											{this.props.translate("Cancel")}
										</Button>
									</div>
								</div>
							</form>
						)
					}}
				/>
			</div>
		);
	}
}

function mapStateToProps(state, ownProps) {
	let initialValues = null;
	if (state.planning.active_plan != null) {
		initialValues = state.planning.active_plan;
	}

	if (state.Blocks.reference != null) {
		initialValues.blocks = JSON.parse(JSON.stringify(state.Blocks.reference));

		if (initialValues.blocks != null && initialValues.blocks.length > 0) {
			/**
			 * Track planning with existing block becuase we have support tickets where the user says the content is deleted.
			 */
			initialValues.blocks.forEach((block) => {
				appInsights.trackTrace({
					message: "EDU024 | Planning with exiting block"
				}, {
					properties: {
						category: "planningForm-" + block.referenceId,
						blockId: block.id,
						valueLength: block.value != null ? block.value.length : 0,
					}
				});
			});
		}

		initialValues.assessmentBlocks = initialValues.blocks.filter(block => block.type == "Haldor.Blocks.AssessmentBlock");

		if (ownProps.cloneView == true) {
			initialValues.blocks = initialValues.blocks.filter(block => {
				return block.type != 'Haldor.Blocks.Assignment';
			});
		}
	}

	return {
		initialValues,
		translate: translate(state.Languages.translations),
		status: state.status.status,
		assessments: state.assessments.assessments,
		services: state.Services.availableServices,
		currentUser: state.user.currentUser,
		createdPlan: state.planning.createdPlanId,
	};
}

export default withRouter(connect(mapStateToProps, {
	getGroupById,
	addError,
	getPlanDetails,
	updatePlan,
	createPlan,
	saveBlocksOnReference,
	updateBlocksOnReference,
	deleteBlock,
	createAssessmentBlock,
	updateAssessmentBlock,
	toggleSelectedSection,
	clearSelectedSections
})(SinglePlanForm));